export const SET_USER = 'SET_USER';
export const SHOW_MAIN_PRELOADER = 'SHOW_MAIN_PRELOADER';
export const SET_POSTS = 'SET_POSTS';
export const SET_CURRENT_POST = 'SET_CURRENT_POST';
export const SET_CURRENT_POST_COMMENTS = 'SET_CURRENT_POST_COMMENTS';
